import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";

export const useMenuStore = defineStore('menuStore', {
    state: () => ({
        isSidenavOpen: false,
        isProfileSidenavOpen: false,
        isMenuCatalogOpen: false,

        menuItems: [],
        activeCatalog: 0,

        showCatalogPing: false,
        pingColor: 'bg-red-600',
    }),

    getters: {
        activeCategory: (state) => {
            if (!Array.isArray(state.menuItems) || !state.menuItems.length) {
                return null;
            }

            return state.menuItems[state.activeCatalog] ?? null;
        },
    },

    actions: {
        setMenuItems(items) {
            this.menuItems = Array.isArray(items) ? items : [];
            this.activeCatalog = 0;
        },

        triggerCatalogButtonPing(pingColor) {
            this.pingColor = pingColor;
            this.showCatalogPing = true;

            setTimeout(() => {
                this.showCatalogPing = false;
            }, 800);
        },

        openMenuCatalog() {
            this.isMenuCatalogOpen = true;

            if (!Array.isArray(this.menuItems)) {
                this.menuItems = [];
            }

            if (this.activeCatalog < 0 || this.activeCatalog >= this.menuItems.length) {
                this.activeCatalog = 0;
            }

            this.setBodyOverflow();
        },

        closeMenuCatalog() {
            if (this.isMenuCatalogOpen) {
                this.isMenuCatalogOpen = false;
                this.setBodyOverflow();
            }
        },

        toggleMenuCatalog() {
            this.isMenuCatalogOpen = !this.isMenuCatalogOpen;

            if (this.isMenuCatalogOpen) {
                if (!Array.isArray(this.menuItems)) {
                    this.menuItems = [];
                }

                if (this.activeCatalog < 0 || this.activeCatalog >= this.menuItems.length) {
                    this.activeCatalog = 0;
                }
            }

            this.setBodyOverflow();
        },

        changeActiveCatalogMenu(index) {
            if (!Array.isArray(this.menuItems)) {
                return;
            }

            if (index < 0 || index >= this.menuItems.length) {
                return;
            }

            this.activeCatalog = index;
        },


        toggleProfileSidenav() {
            this.isProfileSidenavOpen = !this.isProfileSidenavOpen;
            this.setBodyOverflow();
        },
        toggleSidenav() {
            this.isSidenavOpen = !this.isSidenavOpen;
        },

        openSidenav() {
            this.isSidenavOpen = true;
        },

        closeSidenav() {
            this.isSidenavOpen = false;
        },

        closeProfileSidenav() {
            if (this.isProfileSidenavOpen) {
                this.isProfileSidenavOpen = false;
                this.setBodyOverflow();
            }
        },

        setBodyOverflow() {
            const themeStore = useThemeStore();
            themeStore.setBodyOverflow(
                this.isSidenavOpen || this.isMenuCatalogOpen || this.isProfileSidenavOpen
            );
        },
    }
});
